import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _4f3fb732 = () => interopDefault(import('../pages/checkout.vue' /* webpackChunkName: "pages/checkout" */))
const _0218541c = () => interopDefault(import('../pages/happy-breakfast.vue' /* webpackChunkName: "pages/happy-breakfast" */))
const _824a79aa = () => interopDefault(import('../pages/happy-fruit.vue' /* webpackChunkName: "pages/happy-fruit" */))
const _1a31d17e = () => interopDefault(import('../pages/happy-lunch.vue' /* webpackChunkName: "pages/happy-lunch" */))
const _5d4bd951 = () => interopDefault(import('../pages/happy-meetings.vue' /* webpackChunkName: "pages/happy-meetings" */))
const _be92bb6c = () => interopDefault(import('../pages/happy-moments.vue' /* webpackChunkName: "pages/happy-moments" */))
const _471e3da4 = () => interopDefault(import('../pages/happy-takeaway.vue' /* webpackChunkName: "pages/happy-takeaway" */))
const _016988a6 = () => interopDefault(import('../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _9ccfed52 = () => interopDefault(import('../pages/maintenance.vue' /* webpackChunkName: "pages/maintenance" */))
const _f9ef2b5e = () => interopDefault(import('../pages/orders.vue' /* webpackChunkName: "pages/orders" */))
const _7ce66d83 = () => interopDefault(import('../pages/privacy-policy.vue' /* webpackChunkName: "pages/privacy-policy" */))
const _5c82ab88 = () => interopDefault(import('../pages/tak-for-din-henvendelse.vue' /* webpackChunkName: "pages/tak-for-din-henvendelse" */))
const _7fb8d537 = () => interopDefault(import('../pages/user.vue' /* webpackChunkName: "pages/user" */))
const _cbe01220 = () => interopDefault(import('../pages/posts/concept.vue' /* webpackChunkName: "pages/posts/concept" */))
const _64e37931 = () => interopDefault(import('../pages/posts/invite.vue' /* webpackChunkName: "pages/posts/invite" */))
const _e1fef088 = () => interopDefault(import('../pages/user-settings/addresses.vue' /* webpackChunkName: "pages/user-settings/addresses" */))
const _7ff40a02 = () => interopDefault(import('../pages/user-settings/corporate.vue' /* webpackChunkName: "pages/user-settings/corporate" */))
const _220777b2 = () => interopDefault(import('../pages/user-settings/coupons.vue' /* webpackChunkName: "pages/user-settings/coupons" */))
const _2fd0008a = () => interopDefault(import('../pages/user-settings/orders.vue' /* webpackChunkName: "pages/user-settings/orders" */))
const _2b1324a0 = () => interopDefault(import('../pages/user-settings/payment.vue' /* webpackChunkName: "pages/user-settings/payment" */))
const _dd0a1a7a = () => interopDefault(import('../pages/user-settings/profile.vue' /* webpackChunkName: "pages/user-settings/profile" */))
const _747a3236 = () => interopDefault(import('../pages/user-settings/sharedmeals.vue' /* webpackChunkName: "pages/user-settings/sharedmeals" */))
const _188b65e9 = () => interopDefault(import('../pages/user-settings/support.vue' /* webpackChunkName: "pages/user-settings/support" */))
const _24f46c21 = () => interopDefault(import('../pages/user-settings/terms.vue' /* webpackChunkName: "pages/user-settings/terms" */))
const _35a39896 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _9ff8ac46 = () => interopDefault(import('../pages/order/_uuid.vue' /* webpackChunkName: "pages/order/_uuid" */))
const _4b8d9957 = () => interopDefault(import('../pages/payment-verify/_uuid.vue' /* webpackChunkName: "pages/payment-verify/_uuid" */))
const _0514c1b8 = () => interopDefault(import('../pages/restaurant/_slug.vue' /* webpackChunkName: "pages/restaurant/_slug" */))
const _644da4b2 = () => interopDefault(import('../pages/supplier-chain/_slug.vue' /* webpackChunkName: "pages/supplier-chain/_slug" */))
const _2f11a81a = () => interopDefault(import('../pages/supplier/_slug.vue' /* webpackChunkName: "pages/supplier/_slug" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/checkout",
    component: _4f3fb732,
    name: "checkout"
  }, {
    path: "/happy-breakfast",
    component: _0218541c,
    name: "happy-breakfast"
  }, {
    path: "/happy-fruit",
    component: _824a79aa,
    name: "happy-fruit"
  }, {
    path: "/happy-lunch",
    component: _1a31d17e,
    name: "happy-lunch"
  }, {
    path: "/happy-meetings",
    component: _5d4bd951,
    name: "happy-meetings"
  }, {
    path: "/happy-moments",
    component: _be92bb6c,
    name: "happy-moments"
  }, {
    path: "/happy-takeaway",
    component: _471e3da4,
    name: "happy-takeaway"
  }, {
    path: "/login",
    component: _016988a6,
    name: "login"
  }, {
    path: "/maintenance",
    component: _9ccfed52,
    name: "maintenance"
  }, {
    path: "/orders",
    component: _f9ef2b5e,
    name: "orders"
  }, {
    path: "/privacy-policy",
    component: _7ce66d83,
    name: "privacy-policy"
  }, {
    path: "/tak-for-din-henvendelse",
    component: _5c82ab88,
    name: "tak-for-din-henvendelse"
  }, {
    path: "/user",
    component: _7fb8d537,
    name: "user"
  }, {
    path: "/posts/concept",
    component: _cbe01220,
    name: "posts-concept"
  }, {
    path: "/posts/invite",
    component: _64e37931,
    name: "posts-invite"
  }, {
    path: "/user-settings/addresses",
    component: _e1fef088,
    name: "user-settings-addresses"
  }, {
    path: "/user-settings/corporate",
    component: _7ff40a02,
    name: "user-settings-corporate"
  }, {
    path: "/user-settings/coupons",
    component: _220777b2,
    name: "user-settings-coupons"
  }, {
    path: "/user-settings/orders",
    component: _2fd0008a,
    name: "user-settings-orders"
  }, {
    path: "/user-settings/payment",
    component: _2b1324a0,
    name: "user-settings-payment"
  }, {
    path: "/user-settings/profile",
    component: _dd0a1a7a,
    name: "user-settings-profile"
  }, {
    path: "/user-settings/sharedmeals",
    component: _747a3236,
    name: "user-settings-sharedmeals"
  }, {
    path: "/user-settings/support",
    component: _188b65e9,
    name: "user-settings-support"
  }, {
    path: "/user-settings/terms",
    component: _24f46c21,
    name: "user-settings-terms"
  }, {
    path: "/",
    component: _35a39896,
    name: "index"
  }, {
    path: "/order/:uuid?",
    component: _9ff8ac46,
    name: "order-uuid"
  }, {
    path: "/payment-verify/:uuid?",
    component: _4b8d9957,
    name: "payment-verify-uuid"
  }, {
    path: "/restaurant/:slug?",
    component: _0514c1b8,
    name: "restaurant-slug"
  }, {
    path: "/supplier-chain/:slug?",
    component: _644da4b2,
    name: "supplier-chain-slug"
  }, {
    path: "/supplier/:slug?",
    component: _2f11a81a,
    name: "supplier-slug"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
